// extracted by mini-css-extract-plugin
module.exports = {"root":"Sidebar_root__l5bxc","wrapper":"Sidebar_wrapper___7ATW"};